<div class="p-3 component_status_card">
    <i aria-hidden="true" class="fas fa-xs fa-circle pe-1" [ngClass]="status === 'UP' ? 'text-success' : 'text-danger'"></i>
    {{ name }}
</div>
